import React from "react";
import OperatorServiceTickets from "../../components/dashboard/OperatorServiceTickets";
import { getOperatorOdooTickets } from "../../redux/actions/TicketActions";

// Tickets to create or reactivate the clients' ERP accounts
const fetchOdooTickets = (token, country) =>
  getOperatorOdooTickets(token, "odoo", country);

const OperatorOdoo = () => (
  <OperatorServiceTickets
    serviceCode="odoo"
    title="Comptes ERP"
    lead="Création et réactivation des comptes ERP des clients."
    fetchTickets={fetchOdooTickets}
    allowCreate={false}
  />
);

export default OperatorOdoo;
